import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');

export const Spacer = styled.div`
  background-color: ${colors.N40};
  border: none;
  height: 1px;
  margin: 20px 0;
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/Spacer.js